export default {
  data() {
    return {
      activeSalary: this.$route.query.salary || null
    }
  },
  methods: {
    setActiveSalary(value) {
      this.activeSalary = value

      // update query params
      const query = Object.assign({}, this.$route.query);

      delete query.salary;

      query.page = 1;

      if (this.$route.query !== query) {
        // to avoid duplicate navigation
        this.$router.push({ query: query });
      }
    }
  },
  watch: {
    activeSalary(newValue) {
      const query = Object.assign({}, this.$route.query, { salary: newValue });

      if (!newValue || newValue == '-1') {
        delete query.salary
      }

      const sameNumOfParams = Object.keys(this.$route.query).length === Object.keys(query).length

      if (sameNumOfParams) {
        const sameParams = Object.keys(this.$route.query).every(key => this.$route.query[key] === query[key])
        if (!sameParams) {
          this.$router.push({ query: query })
        }
      } else {
        this.$router.push({ query: query })
      }
    }
  }
}
